// Loader.js
import React from 'react';
import './Loader.css'; // Crea este archivo CSS

const Loader = () => {
    return (
        <div className="loader-overlay">
            <div className="loader"></div>
        </div>
    );
};

export default Loader;
